// src/app/core/guards/login.guard.ts
import { inject } from "@angular/core";
import { CanMatchFn, RedirectCommand, Router } from "@angular/router";
import { AuthService } from "../../features/auth/services/auth/auth.service";

export const canMatchLoginGuard: CanMatchFn = (route, segments) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.isAuthenticated) {
    // If already logged in, redirect to dashboard
    return new RedirectCommand(router.parseUrl('/dashboard'));
  }

  return true; // otherwise allow showing login page
};
